import { TableCell, TableRow } from '@mui/material';
import { IArea, ISeminars } from '../../redux/seminars/types';
import {
  MAIN_COLOR,
  MAIN_LIGHT_COLOR,
  SECOND_LIGHT_GRAY,
} from '../../themes/colors';
import { TABLE_CELL } from '../../themes/fonts';
import { makeStyles } from '@mui/styles';
import { getDate } from '../../libs/utils/formatDate';
import { translate } from '../../libs/utils';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';

interface Props {
  data: ISeminars[] | undefined;
  onClickDetail: (seminarId: number) => void;
  onClickEdit: (seminarId: number) => void;
}

const useStyles = makeStyles({
  tableCellText: {
    color: `${SECOND_LIGHT_GRAY} !important`,
    fontSize: `${TABLE_CELL} !important`,
  },

  icon: {
    color: MAIN_COLOR,
    '&:hover': {
      color: MAIN_LIGHT_COLOR,
      cursor: 'pointer',
    },
  },
  noScrollbar: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

const TableBody = ({ data, onClickDetail, onClickEdit }: Props) => {
  const styles = useStyles();

  const handleRenderStatus = (status: boolean) => {
    return status
      ? translate('seminar.list.table.status.open')
      : translate('seminar.list.table.status.close');
  };

  const handleRenderTargetArea = (targetArea: IArea[]) => {
    const areaNames = targetArea.map((area: IArea) => area.area_name);
    return areaNames.join(', ');
  };

  return (
    <>
      {data?.map((row, rowIndex) => (
        <TableRow key={rowIndex}>
          <TableCell
            align="center"
            key="title"
            className={styles.tableCellText}
          >
            {row['title']}
          </TableCell>
          <TableCell
            align="center"
            key="organizer_name"
            className={styles.tableCellText}
          >
            {row['organizer_name']}
          </TableCell>
          <TableCell
            style={{ minWidth: '65px' }}
            align="left"
            key="target_area"
            className={styles.tableCellText}
          >
            {handleRenderTargetArea(row['target_area'])}
          </TableCell>
          <TableCell
            style={{ minWidth: '80px' }}
            align="center"
            key="apply_start_at"
            className={styles.tableCellText}
          >
            <div
              style={{
                maxHeight: '70px',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
              className="noScrollbar"
            >
              <div>
                {getDate(row['seminar_start_time'].toString(), 'YYYY/MM/DD')}
              </div>
              {row['additional_dates'].map((d, idx) => (
                <div key={idx}>
                  {`${getDate(d['date'].toString(), 'YYYY/MM/DD')}` + '\r\n'}
                </div>
              ))}
            </div>
          </TableCell>
          <TableCell
            align="center"
            key="apply_end_at"
            className={styles.tableCellText}
          >
            {getDate(row['apply_start_at'].toString(), 'YYYY/MM/DD')}~
            {getDate(row['apply_end_at'].toString(), 'YYYY/MM/DD')}
          </TableCell>
          <TableCell align="center" key="open" className={styles.tableCellText}>
            {handleRenderStatus(row['open'])}
          </TableCell>
          <TableCell
            align="center"
            key="detail"
            className={styles.tableCellText}
          >
            <InfoIcon
              className={styles.icon}
              onClick={() => onClickDetail(row.seminar_id)}
            />
          </TableCell>
          <TableCell
            align="center"
            key="edit"
            sx={{ color: SECOND_LIGHT_GRAY, fontSize: TABLE_CELL }}
          >
            <EditIcon
              className={styles.icon}
              onClick={() => onClickEdit(row.seminar_id)}
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
export default TableBody;
